import React from 'react';

import { Box } from '@/shared/ui/box';

import { H1_HeadingBoldH4 } from '@/shared/ui/typography2';

export const BonusHeader = ({ t }) => {
  return (
    <Box
      $display="flex"
      $justifyContent={['center', 'flex-start']}
      $alignItems="center"
      $padding={['60px 0 30px 0', '24px 18px 0 18px']}
    >
      <H1_HeadingBoldH4>{t('title')}</H1_HeadingBoldH4>
    </Box>
  );
};
